var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { map } from 'rxjs/operators';
import { Languages } from '@app/core/models';
import { AppStateStore } from './app.store';
import { AppStateQuery } from './app.query';
var AppState = /** @class */ (function () {
    function AppState(store, query) {
        this.store = store;
        this.query = query;
    }
    AppState.prototype.isAuthenticated = function () {
        return this.query.select(function (state) { return state.authenticated; });
    };
    AppState.prototype.getLanguage = function () {
        return this.query
            .select(function (state) { return state.language; })
            .pipe(map(function (identifier) { return Languages[identifier]; }));
    };
    AppState.prototype.setAuthenticated = function (status) {
        this.store.update(function (state) { return (__assign({}, state, { authenticated: status })); });
    };
    AppState.prototype.setLanguage = function (lang) {
        this.store.update(function (state) { return (__assign({}, state, { language: lang.identifier })); });
    };
    AppState.prototype.getError = function () {
        return this.query.select(function (state) { return state.error; });
    };
    AppState.prototype.setError = function () {
        this.store.update(function (state) { return (__assign({}, state, { error: true })); });
    };
    AppState.prototype.resetError = function () {
        this.store.update(function (state) { return (__assign({}, state, { error: false })); });
    };
    return AppState;
}());
export { AppState };
